import { render, staticRenderFns } from "./DialogEditKeyword.vue?vue&type=template&id=6fe465c9"
import script from "./DialogEditKeyword.vue?vue&type=script&lang=js"
export * from "./DialogEditKeyword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports